import { render } from "./ProductDetail.vue?vue&type=template&id=51620a44&scoped=true&ts=true"
import script from "./ProductDetail.ts?vue&type=script&lang=ts"
export * from "./ProductDetail.ts?vue&type=script&lang=ts"

import "./ProductDetail.scss?vue&type=style&index=0&id=51620a44&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51620a44"]])

export default __exports__